const normalizeText = (value) => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.replace(/\s+/g, ' ').trim();
};

export const normalizeStyleTag = (value) => normalizeText(value);

export const normalizeStyleTagKey = (value) => normalizeStyleTag(value).toLowerCase();

export const normalizeStyleTagList = (values, { splitCommas = false } = {}) => {
  const rawValues = Array.isArray(values) ? values : [values];
  const seen = new Set();
  const normalized = [];

  rawValues.forEach((value) => {
    const pieces = splitCommas && typeof value === 'string'
      ? value.split(',')
      : [value];

    pieces.forEach((piece) => {
      const tag = normalizeStyleTag(piece);
      if (!tag) {
        return;
      }
      const key = normalizeStyleTagKey(tag);
      if (seen.has(key)) {
        return;
      }
      seen.add(key);
      normalized.push(tag);
    });
  });

  return normalized;
};

export const buildBandStyleTags = (band) => normalizeStyleTagList([
  ...(Array.isArray(band?.styleTags) ? band.styleTags : []),
  ...(Array.isArray(band?.genres) ? band.genres : []),
  ...(Array.isArray(band?.styles) ? band.styles : []),
]);

export const styleTagsSignature = (values) => (
  normalizeStyleTagList(values)
    .map(normalizeStyleTagKey)
    .join('\n')
);

export const formatStyleTagForDisplay = (value) => {
  const tag = normalizeStyleTag(value);
  if (!tag) return '';
  if (/[A-Z]/.test(tag)) return tag;
  return tag.replace(/\b\w/g, (chr) => chr.toUpperCase());
};

export const formatStyleTagsForDisplay = (values, separator = ' · ') => (
  normalizeStyleTagList(values)
    .map(formatStyleTagForDisplay)
    .filter(Boolean)
    .join(separator)
);

export const bandHasStyleTag = (band, style) => {
  const target = normalizeStyleTagKey(style);
  if (!target) return true;
  return buildBandStyleTags(band).some((tag) => normalizeStyleTagKey(tag) === target);
};
